(() => {
  const initUmbroMixMastering = () => {
      const root = document.getElementById('umbro-mix-page-en');
      if (!root || root.dataset.ready === 'true') return;
    
      root.dataset.ready = 'true';
      root.classList.add('umbro-mix-js');
    
      const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
      const revealItems = root.querySelectorAll('[data-reveal]');
    
      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealItems.forEach((item) => item.classList.add('visible'));
      } else {
        const revealObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });
    
        revealItems.forEach((item) => revealObserver.observe(item));
      }
    
      const iframe = root.querySelector('iframe[data-mixflip-src]');
    
      const loadMixFlip = () => {
        if (!iframe || iframe.dataset.loaded === 'true') return;
        iframe.dataset.loaded = 'true';
        iframe.src = iframe.dataset.mixflipSrc;
    
        iframe.addEventListener('load', () => {
          if (document.querySelector('script[data-umbro-mixflip-resizer]')) return;
          const script = document.createElement('script');
          const playerId = (iframe.dataset.mixflipSrc || '').split('/').filter(Boolean).pop();
          script.src = `https://mfembed.producerapps.com/embed-resize.js?id=${encodeURIComponent(playerId || '3e239b5b-13fc-4c56-8f78-d83f43c6fb39')}`;
          script.defer = true;
          script.dataset.umbroMixflipResizer = 'true';
          document.body.appendChild(script);
        }, { once: true });
      };
    
      if (iframe) {
        if ('IntersectionObserver' in window) {
          const playerObserver = new IntersectionObserver((entries, observer) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            loadMixFlip();
            observer.disconnect();
          }, { rootMargin: '0px', threshold: 0.01 });
          playerObserver.observe(iframe);
        } else {
          loadMixFlip();
        }
      }
    
      if (!reduceMotion && 'IntersectionObserver' in window) {
        const animatedSections = root.querySelectorAll('.umbro-mix-logo-marquee, .umbro-mix-testimonial-wall');
        const animationObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => entry.target.classList.toggle('is-active', entry.isIntersecting));
        }, { threshold: 0.01 });
        animatedSections.forEach((section) => animationObserver.observe(section));
      }
    
      root.querySelectorAll('a[href^="#"]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = root.querySelector(link.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        });
      });
  };

  initUmbroMixMastering();
  document.addEventListener('shopify:section:load', initUmbroMixMastering);
})();
